import MainService from "../Main";
import * as operations from "./StripeSession.graphql";

class StripeSessionService extends MainService {
	constructor(options) {
		super(options);
		this.patch(operations);
	}
}

export default StripeSessionService;
